import { inventoryService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, inventories: [], inventory: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        inventoryService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        inventoryService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/inventories');
                    dispatch('alert/success', "Inventory Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/inventories');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        inventoryService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/inventories');
                    dispatch('alert/success', "Inventory Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/inventories');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        inventoryService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      inventoryService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/inventories');
                  dispatch('alert/success', "Inventory Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/inventories');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_inventory_by_account({ dispatch, commit }, data) {
        commit('request');

        inventoryService.get_inventory_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  inventories: state => {
    return state.inventories
  },
  inventory: state => {
    return state.inventory
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.inventory = {};
        state.inventories = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.inventory = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.inventories = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const inventories = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
